import clsx from "clsx"
import type { HTMLAttributes, ReactNode } from "react"

const ErrorMessage = ({
  children,
  className,
  ...props
}: {
  children?: ReactNode
  className?: string
} & HTMLAttributes<HTMLDivElement>) => {
  if (!children) return null

  return (
    <div
      {...props}
      className={clsx(
        "text-pretty font-semibold text-red-600 text-sm/5 dark:text-red-400",
        className
      )}
    >
      {children}
    </div>
  )
}

export default ErrorMessage
